var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 14,
    viewBox: "0 0 9 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.47125 13.7317C6.64487 13.9053 6.86584 14 7.12627 14C7.64713 14 8.06539 13.5896 8.06539 13.0688C8.06539 12.8083 7.9549 12.5716 7.77339 12.3901L2.24915 6.99211L7.77339 1.60992C7.9549 1.42841 8.06539 1.18377 8.06539 0.931229C8.06539 0.410372 7.64713 0 7.12627 0C6.86584 0 6.64487 0.0947012 6.47125 0.26832L0.331454 6.26607C0.110485 6.47125 0.00789177 6.72379 0 7C0 7.27621 0.110485 7.51297 0.331454 7.72604L6.47125 13.7317Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackButton);
export default __webpack_public_path__ + "static/media/backButton.379cf1467cb2d628e7d1fca210c8e05a.svg";
export { ForwardRef as ReactComponent };